import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { FilterParams } from '@claranet/node-search-filter';
import { ErrorService } from '@app/services/error.service';
import { toParams } from '@shared/utils/query-to-params';
import { Factory } from '@data/models/factory.model';

export const FACTORY_SERVICE_API_ROOT = '/core/v1/factories';
export const PRODUCT_FACTORY_SERVICE_API_ROOT = '/core/v1/product-factories';

interface ListFactories {
    factories: Factory[];
    totalSize: number;
}

interface ProductFactories {
    productFactories: {
        factories: string[];
        productId: string;
    }[];
}

@Injectable()
export class FactoryService {

    private errors;

    constructor(
        private errorService: ErrorService,
        private http: HttpClient
    ) {
        this.errors = this.errorService.factoryServiceErrors;
    }

    public findFactories(filterParams?: FilterParams): Observable<ListFactories> {
        const params = toParams({ ...filterParams, includeTotal: true });
        return this.http.get<ListFactories>(FACTORY_SERVICE_API_ROOT, { params }).pipe(
            map((result) => ({ factories: result.factories.map(factory => new Factory(factory)), totalSize: result.totalSize })),
            catchError(this.errorService.errorHandler<ListFactories>(this.errors, 'Récupération des factories', {factories: [], totalSize: 0 }))
        );
    }

    public getFactory(factoryId: string): Observable<Factory> {
        return this.http.get<Factory>(FACTORY_SERVICE_API_ROOT + '/' + factoryId).pipe(
            map((factory) => new Factory(factory)),
            catchError(this.errorService.errorHandler<Factory>(this.errors, 'Récupération des données de la factory', null))
        );
    }

    public getProductFactories(productIds: string[]): Observable<ProductFactories> {
        const params = toParams({
            filter: `productId:(${productIds.join('|')})`,
            page: 1,
            limit: productIds.length,
        });

        return this.http.get<ProductFactories>(PRODUCT_FACTORY_SERVICE_API_ROOT, { params }).pipe(
            catchError(this.errorService.errorHandler<ProductFactories>(this.errors, 'Récupération des factory des produits', {
                productFactories: []
            }))
        );
    }
}
